module.exports = __webpack_public_path__ + "img/vr.4bc295f7.svg";